<template>
  <v-app>
    <v-main class="main-container">
      <router-view></router-view>
      <Rating />
      <AffirmationDialog
        :isOpen="expiredToken"
        body="Your session has expired. You will be redirected to the Login page."
        title="Session Expired"
        buttonText="Okay"
        :isHold = true
        @okay="backToAuth"
      />
      <AffirmationDialog
        v-if="naccc_token"
        :isOpen="expiredTokenNaccc"
        body="Your session has expired. You will be redirected to the CATCH homepage."
        title="Session Expired"
        buttonText="Okay"
        :isHold = true
        @okay="backToAuthNACCC"
      />
    </v-main>
  </v-app>
</template>

<script lang="ts">
import Vue from 'vue'
import axios from 'axios'
import Options from 'vue-class-component'
import { Watch } from 'vue-property-decorator'

import Rating from '@/components/Rating.vue'
import AffirmationDialog from '@/components/AffirmationDialog.vue'

import { mapGetters } from 'vuex'
import { getPath } from './utils/general-utils'
import { AUTH_EXPIRED_TOKEN, AUTH_SIGN_OUT, DELETE_CART } from './store/types'
import { API_URL } from './config/constants'
import { ICart } from './store/modules/cart'
import { isCartExpired } from './utils/cart'


axios.defaults.baseURL = API_URL + '/api/v1'

@Options({
  components:{
    Rating,
    AffirmationDialog,
  },
  computed: {
    ...mapGetters([
      'isCredentialsLoaded',
      'expiredToken',
      'expiredTokenNaccc',
      'naccc_token',
      'isCMSGMerchant',
      'isNACCMerchant',
      'cart'
    ])
  }
})
export default class App extends Vue {
  getPath = getPath
  isCredentialsLoaded!: boolean
  expiredToken!: boolean
  expiredTokenNaccc!: boolean
  naccc_token!: string
  isCMSGMerchant!: boolean
  isNACCMerchant!: boolean
  cart?: ICart
  isCMSGMerchantOpen = false
  isNoticeOpen = false

  @Watch('isCredentialsLoaded', { immediate: true })
  onCredentialLoaded(newValue: boolean): void {
    if (newValue) {
      this.$store.dispatch('loadCheckoutCart')
      if (isCartExpired(this.cart)) {
        this.$store.dispatch(DELETE_CART)
      }
    }
  }

  mounted(): void {
    this.isNoticeOpen = true
  }

  async updated(): Promise<void> {
    if (isCartExpired(this.cart)) {
      this.$store.dispatch(DELETE_CART)
    }
  }

  async backToAuth(): Promise<void> {
    this.$store.commit(AUTH_EXPIRED_TOKEN, false)
    this.$store.commit(AUTH_SIGN_OUT)
    await this.$store.dispatch('resetCheckoutCart')
    if (this.isNACCMerchant) {
      window.open('https://www.catch.sg/', '_top')
    } else {
      this.$router
        .push(getPath('/auth'))
        .catch((err) => err.message)
    }
  }
  
  async backToAuthNACCC(): Promise<void> {
    this.$store.commit(AUTH_SIGN_OUT)
    await this.$store.dispatch('resetCheckoutCart')
    window.open('https://www.catch.sg/', '_top')
  }

}
</script>

<style lang="scss">
@import "@/styles/global.scss";
.main-container {
  position: relative;
}
</style>
